import _kebabCase from 'lodash/kebabCase';

import {
    Google,
    GoogleTransformers,
} from 'reaxl-analytics-handlers';

import getInventoryOwnerById from '@/analytics/utilities/getInventoryOwnerById';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

export function ownerNextCTAClick({
    state,
    dataLayer,
    data = {},
}, option) {

    const {
        inventoryId,
        inquiryLabel = '',
    } = data;
    const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
    const listingType = inventoryWithOwner?.listingType ? inventoryWithOwner?.listingType.toLowerCase() : (data?.listingType || '').toLowerCase();
    const inquirySelection = inquiryLabel.trim().replace(/\b's\b/g, '');
    const linkCopy = _kebabCase(inquirySelection);
    const cmp = 'intrst_next';

    Google.sendClickEvent({
        eventElement: `vdp_${listingType}`,
        eventResult: `cta::next::${linkCopy}`,
        eventNonInteractive: false,
        eventData: {
            vehicle: {
                ...googleInventoryTransformer(inventoryWithOwner, { target: 'vehicle', dataLayer }),
            },
        },
    }, option);

    return { cmp };
}

export function ownerChangeLocationClick({
    state,
    dataLayer,
    data = {},
}, option) {

    const {
        inventoryId,
        zip = '',
    } = data;
    const inventoryWithOwner = getInventoryOwnerById(state, inventoryId);
    const cmp = 'chg_zip';

    Google.sendClickEvent({
        eventElement: 'dhs',
        eventResult: `cta::change-zip::${zip}`,
        eventNonInteractive: true,
        eventData: {
            vehicle: {
                ...googleInventoryTransformer(inventoryWithOwner, { target: 'vehicle', dataLayer }),
            },
        },
    }, option);

    return { cmp, zip };
}

export default {
    ownerNextCTAClick,
    ownerChangeLocationClick,
};
